module.exports = __webpack_public_path__ + "media/interested_companies/images/star00-8445e6d53bb960cc30ce79390aadaf51.svg";